import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

const store = new Vuex.Store({

	state: {
		menuName: null,
		menuPath: null,
		notEnough:false,
		isLogin:false
	},
	mutations: {
		breadcrumb(state, name, path) { //面包屑
			state.menuName = name;
			state.menuPath = path;
		},
		setNotEnough(state,success){
		  state.notEnough=success;
		}
	}
})

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js